<div class="exotics-header">
  <div class="exotics-header__left">
    <div>
      <app-main-menu></app-main-menu>
    </div>
    <button
      *ngIf="showRfqButton"
      (click)="createRfq()"
      [disabled]="isDirectRfqDisabled"
      class="ui-button ui-button__header primary ui-button--rfq"
      [ngClass]="{ 'simple-tooltip': isDirectRfqDisabled }"
      data-tooltip="Please select a trading entity"
    >
      Direct RFQ
    </button>
  </div>
  <div class="exotics-header__right">
    <div
      class="exotics-header__right__medusa-accounts"
      *ngIf="medusaCredentials?.length"
    >
      <label> Trading Entity: </label>
      <div
        class="clr-select-wrapper exotics-header__right__medusa-accounts__select_wrapper"
      >
        <!-- using blur method as ng-untouched issues with ngModel -->
        <select
          class="clr-select medusa-select"
          (change)="$any($event.target).blur()"
          (blur)="
            medusaLogin(
              $any($event.target).value,
              $any($event.target).value !== medusaAccount.entity
            )
          "
          [ngModel]="medusaAccount.entity"
        >
          <option
            *ngFor="let credential of medusaCredentials"
            [value]="credential.entity"
          >
            {{ credential.entity }}
          </option>
        </select>
      </div>

      <div
        *ngIf="medusaAccount.entity"
        class="exotics-header__right__medusa-accounts__refresh-login"
        (click)="throttledMedusaLogin(medusaAccount.entity)"
        title="Refresh login"
      >
        <cds-icon
          [ngClass]="{
            'exotics-header__right__medusa-accounts__refresh-login--disabled':
              !canLogin
          }"
          shape="refresh"
          size="14"
        ></cds-icon>
        <span
          class="traffic-lights"
          style="--intensity: {{ medusaConnectionStateIntensity }}"
        >
          <cds-icon shape="circle" solid size="14"></cds-icon>
        </span>
        <span
          class="medusaConnectionCountdown"
          *ngIf="medusaConnectionCountdown"
          >{{ medusaConnectionCountdown }}</span
        >
      </div>
    </div>

    <ng-container>
      <button
        class="header-button"
        (click)="onOpenUserPrefsChanged(true)"
        title="Settings"
      >
        <cds-icon shape="cog" size="14"></cds-icon>
      </button>
      <button
        class="header-button header-button--right"
        (click)="toggleSounds()"
        title="Toggle sounds"
      >
        <cds-icon shape="volume-up" size="14" *ngIf="playSounds"></cds-icon>
        <cds-icon shape="volume-mute" size="14" *ngIf="!playSounds"></cds-icon>
      </button>
    </ng-container>
    <button
      type="button"
      class="ui-button primary sign-out"
      [title]="userInfo?.email"
      (click)="signOut()"
    >
      Sign out
    </button>
  </div>
</div>

<div class="exotics-main">
  <as-split
    id="positions-split-area"
    direction="vertical"
    (dragStart)="dragStart()"
    (dragEnd)="dragEnd()"
  >
    <as-split-area
      [size]="80"
      style="position: relative"
      class="scrollable-content"
    >
      <div
        class="exotics-main__top__details"
        *ngFor="let tab of rfqTabs; index as i"
      >
        <app-rfq-container [tabIndex]="i" [tab]="tab"></app-rfq-container>
      </div>

      <div class="exotics-main__top">
        <div
          class="exotics-main__top__details structuring-panel-minimized"
          (click)="showStructuringPanel = true"
          *ngIf="!showStructuringPanel"
          title="Show Strategies Panel"
        >
          <cds-icon shape="resize"></cds-icon>
        </div>
        <div
          class="exotics-main__top__details"
          [ngClass]="{ hide: !showStructuringPanel }"
          [@openClose]="showStructuringPanel ? 'open' : 'closed'"
        >
          <app-strategy-detail></app-strategy-detail>
        </div>

        <div
          class="exotics-main__top__details"
          *ngFor="let directRfq of directRfqs; let i = index"
        >
          <app-direct-rfq [rfqTab]="directRfq" [index]="i"></app-direct-rfq>
        </div>

        <div
          class="exotics-main__top__details"
          *ngIf="providerQuoteTabs.length"
        >
          <app-provider-quote-container></app-provider-quote-container>
        </div>

        <div class="exotics-main__top__details" *ngIf="showStrategiesGrid">
          <app-strategies-viewer
            *ngIf="showStrategiesGrid"
            (loadStrategies)="onLoadStrategies($event)"
            (deleteStrategy)="onDeleteStrategy($event)"
          >
          </app-strategies-viewer>
        </div>

        <div class="exotics-main__top__details" *ngIf="marketsDataActive()">
          <app-markets-detail></app-markets-detail>
        </div>
      </div>
      <app-rfq-timeline *ngIf="rfqTimelineService.displayWindow$ | async">
      </app-rfq-timeline>
      {{ countArray }}
      <ng-container *ngFor="let count of countArray; let i = index">
        <ng-template cdkPortalOutlet></ng-template>
      </ng-container>
    </as-split-area>

    <as-split-area
      *ngIf="positionsDataActive()"
      [size]="20"
      style="overflow: hidden"
      [ngStyle]="isDragging && { zIndex: '9999' }"
    >
      <app-positions-detail></app-positions-detail>
    </as-split-area>
  </as-split>

  <div class="environments">
    <app-fixings *ngIf="showFixings"></app-fixings>
    <app-ir-fixings *ngIf="showIRFixings"></app-ir-fixings>
  </div>
</div>

<div class="trade-capture">
  <app-entities *ngIf="showEntities"></app-entities>
  <app-credit-curves *ngIf="showCreditCurves"></app-credit-curves>
  <app-csa *ngIf="showCsa"></app-csa>
  <app-treasury-curves *ngIf="showTreasuryCurves"></app-treasury-curves>
  <app-schedule-reports
    *ngIf="showScheduleReports"
    [legComponents]="strategyDetailComponent.legComponents"
  ></app-schedule-reports>
  <app-alerts *ngIf="showAlerts"></app-alerts>
  <app-dci
    *ngIf="showDciGrid"
    (loadStrategy)="onLoadStrategies($event, true)"
  ></app-dci>
</div>

<div class="display-definitions">
  <app-currency-pairs *ngIf="showCurrencyPairs"></app-currency-pairs>
  <app-fixing-sources *ngIf="showFixingSources"></app-fixing-sources>
  <app-cutoffs *ngIf="showCutoffs"></app-cutoffs>
  <app-trade-status *ngIf="showTradeStatus"></app-trade-status>
</div>

<app-medusa-login
  *ngIf="showMedusaLoginErrorModal"
  [isModalOpened]="showMedusaLoginErrorModal"
></app-medusa-login>

<app-user-preferences
  *ngIf="userPrefOpen"
  [isModalOpened]="userPrefOpen"
  (userPrefOpenChanged)="onOpenUserPrefsChanged($event)"
  [ngStyle]="{ 'z-index': modalZIndex }"
>
</app-user-preferences>
@if (isBackToBackGridOpen) {
  <ng-container *ngIf="backToBackStateChanged$ | async as backToBackState">
    <app-back-to-back-trades
      [rowData]="backToBackState.rows"
      [timestamp]="backToBackState.timestamp"
      [columnState]="backToBackState.grid.columnState"
    ></app-back-to-back-trades>
  </ng-container>
}

<ng-container *ngIf="pnlBlotterStateChanged$ | async as pnlBlotterState">
  <ng-container *ngIf="pnlPivotStateChanged$ | async as pnlPivotBlotterState">
    <ng-container *ngIf="pnlBlotterState.rows.length">
      <app-pnl-pivot-table
        *ngFor="let grid of pnlPivotBlotterState.grids; let i = index"
        [index]="i"
        [rowData]="pnlBlotterState.rows"
        [headers]="pnlPivotBlotterState.headers"
        [timestamp]="pnlBlotterState.timestamp"
        [columnState]="grid.columnState"
      ></app-pnl-pivot-table>
    </ng-container>
  </ng-container>
</ng-container>

<app-warning-screen
  *ngIf="warningScreenData.warningScreenOpen"
  [isModalOpened]="warningScreenData.warningScreenOpen"
  [headerMessage]="warningScreenData.headerMessage"
  [messageToDisplay]="warningScreenData.messageToDisplay"
  [yesNoOptions]="false"
  (communicate)="warningScreenResponse()"
  (warningOpenChanged)="warningOpenChanged($event)"
  [ngStyle]="{ 'z-index': modalZIndex }"
></app-warning-screen>

<app-activity-modal
  *ngIf="activityState !== 'ACTIVE'"
  [activityState]="activityState"
></app-activity-modal>

<app-credit-lines *ngIf="showCreditLines"></app-credit-lines>

@if (!isProd) {
  <div class="non-prod-warning toast-warning">
    This is a test version (dummy trades only)
  </div>
}
